import { StyledloadingCircleImage } from "./styled";

export const Loading = () => <StyledloadingCircleImage />;
